// src/App.js
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import { BrowserRouter as Router } from 'react-router-dom';
import AnimatedRoutes from './components/AnimatedRoutes';

// Import Helmet
import { Helmet } from 'react-helmet';

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>Pedro's Pizzeria</title>
        <link rel="icon" type="image/png" href="/map.png" />

      </Helmet>

      <Router>
        <Navbar />
        <AnimatedRoutes />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
